// components/common/Pagination.jsx
import React from 'react';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const visiblePageCount = 10; // 한 번에 보일 페이지 버튼 개수
  const currentGroup = Math.floor((currentPage - 1) / visiblePageCount);
  const groupStart = currentGroup * visiblePageCount + 1;
  const groupEnd = Math.min(groupStart + visiblePageCount - 1, totalPages);

  const pages = [];
  for (let i = groupStart; i <= groupEnd; i++) {
    pages.push(i);
  }

  const goToPrev = () => onPageChange(Math.max(1, currentPage - 1));
  const goToNext = () => onPageChange(Math.min(totalPages, currentPage + 1));
  const goToFirst = () => onPageChange(1);
  const goToLast = () => onPageChange(totalPages);

  return (
    <div className="pagination" style={{ textAlign: 'center', marginTop: '20px' }}>
      <button onClick={goToFirst} disabled={currentPage === 1}>
        <img src="/media/paging_arr03.png" alt="처음" />
      </button>
      <button onClick={goToPrev} disabled={currentPage === 1}>
        <img src="/media/paging_arr01.png" alt="이전" />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          style={{
            margin: '0 5px',
            width: '30px',
            height: '30px',
            textAlign: 'center',
            backgroundColor: currentPage === page ? '#007bff' : '#f1f1f1',
            color: currentPage === page ? '#fff' : '#000',
            border: '1px solid #ccc',
            borderRadius: '50px',
            cursor: 'pointer',
          }}
        >
          {page}
        </button>
      ))}

      <button onClick={goToNext} disabled={currentPage === totalPages}>
        <img src="/media/paging_arr02.png" alt="다음" />
      </button>
      <button onClick={goToLast} disabled={currentPage === totalPages}>
        <img src="/media/paging_arr04.png" alt="마지막" />
      </button>
    </div>
  );
}
